export enum HighlightCode {
    SAFETY = 'SAFETY',
    WORTH_THE_MONEY = 'WORTH_THE_MONEY',
    EASY_TO_INSTALL = 'EASY_TO_INSTALL',
    CLEANLINESS = 'CLEANLINESS',
    INSTRUCTION_QUALITY = 'INSTRUCTION_QUALITY',
    INTERNET_SPEED = 'INTERNET_SPEED',
    TRANSFER = 'TRANSFER',
    CONVENIENT_TRAVEL = 'CONVENIENT_TRAVEL',
    REDEEM = 'REDEEM',
    PICK_UP = 'PICK_UP',
    EFFICIENCY = 'EFFICIENCY',
    SKIP_THE_LINE_CONVENIENCE = 'SKIP_THE_LINE_CONVENIENCE',
    FAST_LINE = 'FAST_LINE',
    PUBLIC_TRANSPORTATION_ACCESS = 'PUBLIC_TRANSPORTATION_ACCESS',
    DISTANCE_FROM_CITY_CENTER = 'DISTANCE_FROM_CITY_CENTER',
    FOOD_VARIETY = 'FOOD_VARIETY',
    FOOD_QUALITY = 'FOOD_QUALITY',
    PHOTO_OPPORTUNITY = 'PHOTO_OPPORTUNITY',
    MUST_SEE_LANDMARK = 'MUST_SEE_LANDMARK',
    VIEW = 'VIEW',
    RELAXING = 'RELAXING',
    TOUR = 'TOUR',
    EXPERIENCE = 'EXPERIENCE',
    IMMERSIVE_EXPERIENCE = 'IMMERSIVE_EXPERIENCE',
    LUXURY_EXPERIENCE = 'LUXURY_EXPERIENCE',
    THRILLING_EXPERIENCE = 'THRILLING_EXPERIENCE',
    ROMANTIC_EXPERIENCE = 'ROMANTIC_EXPERIENCE',
    EDUCATIONAL_EXPERIENCE = 'EDUCATIONAL_EXPERIENCE',
    RELIABILITY = 'RELIABILITY',
    DRIVER_FRIENDLINESS = 'DRIVER_FRIENDLINESS',
    QUICK_SERVICE = 'QUICK_SERVICE',
    SERVICE = 'SERVICE',
    STAFF = 'STAFF',
    GUIDE = 'GUIDE',
    FAMILY = 'FAMILY',
    KID = 'KID',
    GROUP = 'GROUP',
    COUPLE = 'COUPLE',
    SOLO = 'SOLO',
    UNKNOWN = 'UNKNOWN',
}
